import { createFileRoute } from '@tanstack/react-router';
import { Verified } from '../pages/Verified';

export const Route = createFileRoute('/verified')({
  component: Verified,
});
